module.exports = __webpack_public_path__ + "static/media/cabecera.9d470015.jpg";